export function formatDate(inputDate) {
  if (!inputDate) return ""; // Handle null, undefined, or empty input
  const date = new Date(inputDate);
  // Check for invalid date
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

export function convertRoleType(roles) {
  let roleType = {
    employee: "EMPLOYEE",
    vendor: "VENDOR",
    location_user: "LOCATION USER",
    location_admin: "LOCATION ADMIN",
    sub_admin: "SUB ADMIN",
    group_admin: "GROUP ADMIN",
  };
  let result = roles.map((role) => roleType[role] || role);
  return result;
}
